import Table from "components/DataTable/Table";
import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import UserSmtpForm from "./UserSmtpForm";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import API from "services/axios";
import authHeader from "services/auth-header";
import { setNotification } from "features/Notification/notificationSlice";

export default function UserSmtpList({
  locationsList,
  selectedUser,
  selectedLocation,
  onSelectSmtp,
  selectedSmtpItem,
  userSmtpList,
  setUserSmtpList,
  getUserSmtpList,
}) {
  const dispatch = useDispatch();

  /* ******************** All States ************************* */
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selected, setSelected] = useState(null);

  /* ******************** All Functions ************************* */

  // Delete Template
  const deleteTemplateData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/user/smtp/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        // refresh current page
        await getUserSmtpList();
        dispatch(
          setNotification({
            message: data?.message || "Deleted",
            type: "success",
          }),
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message || "Failed to delete",
          type: "error",
        }),
      );
    } catch (err) {
      dispatch(setNotification({ message: err.message, type: "error" }));
    } finally {
      setLoading(false);
    }
  };

  /*   Table Functions below
   ********************************************* */
  const buttons = () => (
    <div className="d-flex justify-content-end ">
      <button
        onClick={() => setShowAddModal(true)}
        className="btn btn-primary ms-1"
      >
        Add
      </button>
    </div>
  );
  const table_head = [
    // "ID",
    "Smtp Name",
    "Smtp Email",
    "Action",
  ];

  const table_body = (item) => (
    <tr
      key={item.id}
      onClick={() => onSelectSmtp && onSelectSmtp(item)}
      style={{
        cursor: "pointer",
        backgroundColor:
          selectedSmtpItem?.id === item.id ? "#e7f3ff" : "transparent",
      }}
      className="hover-row"
    >
      {/* <td className="py-1 align-middle">{item.id}</td> */}
      <td className="py-1 align-middle">{item.smtpName}</td>
      <td className="py-1 align-middle">{item.smtpEmail}</td>
      <td className="table-action py-1 align-middle">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setSelected(item);
            setShowAddModal(true);
          }}
          className="btn btn-sm"
        >
          <i className={`mdi mdi-pencil`}></i>
        </button>
        <DeleteModalButton
          btnClass={"btn btn-sm  px-1"}
          deleteFunc={deleteTemplateData}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  /* ******************** All UseEffects ************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      getUserSmtpList();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        {loading && <Spinner />}
        <div className="border-bottom border-1 mb-1 d-flex align-items-center justify-content-between">
          <h4 className="">User Smtp List</h4>
          {/* {buttons()} */}
        </div>
        <Table
          btn1={buttons}
          table_body={table_body}
          table_data={userSmtpList}
          table_head={table_head}
        />
      </div>

      {/* Add Modal */}
      <Modal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        centered
        contentClassName="custom-shadow-sm custom-border-radius"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add User Smtp</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Add Form Content */}
          {selectedUser && (
            <UserSmtpForm
              selectedUser={selectedUser}
              selectedLocation={selectedLocation}
              selected={selected}
              refreshFunc={getUserSmtpList}
              showModal={setShowAddModal}
              locationsList={locationsList}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
